import { withInstall } from '@ll-plus/utils'

import StepItem from './src/step-item.vue'
import Steps from './src/steps.vue'

export const LlSteps = withInstall(Steps)
export const LlStepItem = withInstall(StepItem)

export * from './src/steps'

declare module 'vue' {
  export interface GlobalComponents {
    LlSteps: typeof Steps
    LlStepItem: typeof StepItem
  }
}
